import { gql, useQuery } from '@apollo/client';

export const GET_CURRENT_COMPANY = gql`
  query {
    getCurrentCompany {
      _id
      name
      businessAddress
      email
      logoFileId
      phoneNumber
      timezone
      street
      city
      country
      zipCode
      logoUrl
      ownerMemberId
      subscriptionId
    }
  }
`;

export const useGetCurrentCompany = ({
  onSuccess,
}: { onSuccess?: (company: any) => void } = {}) => {
  const { data, loading } = useQuery(GET_CURRENT_COMPANY, {
    ...(onSuccess && { onCompleted: onSuccess }),
  });

  const getCurrentCompany = data?.getCurrentCompany || {};

  return {
    loading,
    company: getCurrentCompany,
  };
};
